module.exports = ({
    "CDMS803TT001": "PDF ของผู้เข้าร่วมวิจัย",
    "CDMS803TT002": "PDF ของผู้เข้าร่วมวิจัย_ประวัติ",
    "CDMS803H001": "สถานวิจัย",
    "CDMS803H002": "รหัสผู้เข้าร่วมวิจัย",
    "CDMS803H003": "Visit",
    "CDMS803H004": "Page",
    "CDMS803H005": "จำนวนสถานวิจัย",
    "CDMS803H006": "จำนวนผู้เข้าร่วมวิจัย",
    "CDMS803H007": "รหัสผู้ใช้งาน",
    "CDMS803H008": "ชื่อผู้ใช้งาน",
    "CDMS803H009": "วันที่เริ่มต้น",
    "CDMS803H010": "วันที่สิ้นสุด",
    "CDMS803H011": "ไฟล์",
    "CDMS803H012": "สถานะ",
    "CDMS803BTN001": "ประวัติการดาวน์โหลด",
    "CDMS803BTN002": "ดาวน์โหลด",
    "CDMS803BTN003": "ไปที่หน้า PDF ของผู้เข้าร่วมวิจัย",
    "CDMS803OPT001": "แสดงผู้เข้าร่วมวิจัยที่ถูกลบออก",
    "CDMS803OPT002": "สำเร็จ",
    "CDMS803OPT003": "ไม่สำเร็จ",
    "CDMS803OPT004": "อยู่ระหว่างดำเนินการ",
    "CDMS803OPT005": "N/A"
});
